import { getAllPipelineSettingsRpc } from '../../../__generated__/chirp/com/hubspot/leads/rpc/LeadsSettingsRpc';
export const fetchLeadPipelineSettingsRest = (__unusedKey, httpClient) => {
  return httpClient.get('leads/v3/settings/pipeline-settings/all');
};
export const fetchLeadPipelineSettings = rpcClient => {
  return rpcClient.call(getAllPipelineSettingsRpc, {
    request: undefined
  });
};